import { render } from "./CatalogBenefits.vue?vue&type=template&id=44d3d5df"
import script from "./CatalogBenefits.vue?vue&type=script&lang=js"
export * from "./CatalogBenefits.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__